import { App } from 'vue'
import ElementPlus from './element-plus'
import Vant from './vant'
const install = (app: App): void => {
  app.use(ElementPlus)
  app.use(Vant)
  // app.use(ZtPlus);
  // app.use(Rem)
}
export { install }
